
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Datetime from 'vux/src/components/datetime/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
import $ from 'jquery'
import XInput from "vux/src/components/x-input/index";

export default {

components: {
XInput,
PopupPicker,
Group,
XButton,
Flexbox,
FlexboxItem,
Alert,
Confirm,
loadPage,
$,
Datetime
},
data(){
return{
title1:'车位缴费',//缴费名称
value_1:[],
list_1: [[]],
valueTime:'2012/12/12',//缴费时间
endDates:'',
myDilogs:'',
nextEndDates:'',
selectDate:[[],[],[]],//初始化时间选择
phone:'',//电话
mousth1:['1'],
allMonth:[[]],
mycarList:[],//绑定车辆集合
mycarListInfo:[],//缴费明细集合
myTime:[],//选择时间集合
baseRate:'',//基础量
dailogMessage:'',
comnCode:'',
submitable:false,
mousth:'',
show:false,
comnList:'',
showLog:false,
mssl:[],
msrue1:false,
msrue:false,
feeShow:false,
show_1:false,
feeBillList:[],

sMonth:'',
sQx:'',
pkUs:'',
feeMoey:'',
sDate:'',
qsType:'',
useXz:'',
sumMoney:'',
totalFeeMoney:'0.0',
prevValueTime:'',

pkId:'',
disTypes:'',
billCode:'',
dayms:'',
mVals:'',
/*********/
qxTypes:'',
areaPlace:'',
feeStandard:'',
hTime:''
}
},
beforeMount(){
this.show_1 = true;
setTimeout(function() {
this.show_1 = false;
}, 1000);
this.getInitSelectDate();


let url2=global.host+'discountConfig/getListByPark?comnCode='+this.$router.history.current.query.comnCode;
this.$http.get(url2).then(function(res){
let tiems = res.body.result;
this.myTime = new Object();
for(let jm in tiems){
this.myTime[jm] = tiems[jm];
}
this.loadAjax();
console.log("#####");
console.log(this.myTime[0]);

this.disTypes = this.myTime[0].discType;
this.show_1 = false;
},function(err){
this.show_1 = false;
console.log(err)
})

},
mounted(){
if(this.$router.history.current.path == '/carPaycoment'){

document.title = "车辆缴费";
}
let mi = 25;
let arry = [];
for(var i=1;i<25;i++){
this.allMonth[0].push(i.toString());
}
$(".am_font1").parent(".weui-dialog__bd").css({"padding-left":"0.1em","padding-right":"0.1em"})

$(".am_ulist").delegate("li","click",function(){
$(this).find("button").addClass("am_persfors");
$(this).siblings("li").find("button").removeClass("am_persfors");

})
this.msrue = true;
this.msrue1 = false;
},
methods:{
log (str1, str2 = '') {
console.log(str1, str2)
},
onConfirm (val) {
console.log('on-confirm arg', val)

},
async loadAjax(){
let url1=global.host+'parkinginfo/queryParkInfo?phone='+this.$router.history.current.query.phone+'&comnCode='+this.$router.history.current.query.comnCode
await this.$http.get(url1).then(function(res){
let reslt = res.body.result;
let slit = [];
let mdata = "";
this.comnList = res.body.result;
if(res.status==200){
for(var i = 0 ; i < reslt.length; i++){
this.list_1[0].push(reslt[i].park.parkingInfo.pkCode);
this.value_1[0] = this.list_1[0][0]
}
this.onChange(this.list_1[0][0]);
for(let its in reslt){
for(let mitem in reslt[its].car){
mdata = reslt[its].car[mitem].pkCode;
this.mssl.push(reslt[its].car[0].carNo);
this.list_1[0].push(mdata);

}
for(let bm in reslt[its].park){
this.endDates = reslt[its].park.parkingInfo.endDate;
let mdate = this.endDates.split("-");
this.dayms = parseInt(mdate[2]);
if(this.dayms < 10){
this.dayms = '0' + this.dayms;
}
let defaultCount = this.myTime[0].baseRate;
this.valueTime = this.subMonths(this.endDates, defaultCount);


this.nextEndDates = this.valueTime +"-"+this.dayms;

this.setPayTime(defaultCount);
$(".am_ulist > li:eq(0)").find("button").addClass("am_persfors");

if(this.list_1[0][0] == mdata){
this.sDate = reslt[its].park.parkingInfo.endDate;
this.qsType = reslt[its].park.feeItem.feeName;
this.useXz = reslt[its].park.parkingInfo.pkUsed;
this.sumMoney = reslt[its].park.feeRate;
this.pkId = reslt[its].park.parkingInfo.pkId;
}

}

}





let ms = Array.from(new Set(this.list_1[0]))
this.list_1[0] = ms;

this.value_1 = this.list_1[0];
this.onChange(this.list_1[0][0]);

this.sMonth = dateFormat(new Date(this.sDate), 'YYYY-MM');
this.sQx = this.qsType;
this.feeMoey = this.sumMoney + "元/月";
this.pkUs = this.useXz;
}

},function(err){
console.log(err)
})
},
mload(){
this.nextEndDates = this.valueTime +"-"+this.dayms;

},
onChange(index){
this.mycarList = [];
let carCode = "";
for(let ns in this.comnList){
for(let bs in this.comnList[ns].car){
carCode = this.comnList[ns].car[bs].pkCode;
if(index == carCode){
let carNos = this.comnList[ns].car[bs].carNo;
this.mycarList.push(carNos);
}
}
if(index == carCode){
this.sDate = this.comnList[ns].park.parkingInfo.endDate;
this.qsType = this.comnList[ns].park.feeItem.feeName;
this.useXz = this.comnList[ns].park.parkingInfo.pkUsed;
this.sumMoney = this.comnList[ns].park.feeRate;
this.pkId = this.comnList[ns].park.parkingInfo.pkId;
this.qxTypes = this.comnList[ns].park.parkingInfo.pkOwner;
this.areaPlace = this.comnList[ns].park.parkingInfo.pkRegion;
this.feeStandard = this.comnList[ns].park.feeRate;
}
}
this.sMonth = dateFormat(new Date(this.sDate), 'YYYY-MM');
this.sQx = this.qsType;
this.feeMoey = this.sumMoney + "元/月";
this.pkUs = this.useXz;
this.endDates = this.sDate;

this.setToday();

},

serchDetail(){
let url2=global.host + 'parkinginfo/getParkTopic'
this.$http.get(url2).then(function(res){
this.mycarListInfo=res.body.result;
},function(err){
console.log(err);
})

this.showLog = true;
},
cancel(){
this.submitable = false;
},

getMonths(date1 , date2){

date1 = date1.split("-");
date2 = date2.split("-");

var year1 = parseInt(date1[0]) ,
month1 = parseInt(date1[1]) ,
year2 = parseInt(date2[0]) ,
month2 = parseInt(date2[1]) ,

months = (year2 - year1) * 12 + (month2-month1);

this.mousth = months;
return months;
},

subMonths(date , addMonth){

/*let s = $(".vux-datetime").find(".vux-cell-value").text(this.mVals)
console.log(s)*/
addMonth = parseInt(addMonth);

date = date.split("-");

var year = parseInt(date[0]);
var month = parseInt(date[1]);
var sumMonth = parseInt(month+addMonth);
if(sumMonth%12==0){
var chushu = (sumMonth/12)-1;
year = year + chushu;
month = sumMonth - (12*chushu);
}else if(sumMonth > 12){
var chushu = Math.floor(sumMonth/12);
year = year + chushu;
month = sumMonth - (12*chushu);
}else{
month = sumMonth;
}
if(month<10){month="0"+month;}
return year+"-"+month;
},
setPayTime(time,disType){

let timeNum = parseInt(time);
this.feeBillList = [];
for(var i =1;i<=timeNum;i++){
let feeObj = new Object();
feeObj.month = this.subMonths(this.endDates , i);
this.feeBillList.push(feeObj);
this.valueTime = feeObj.month;
}
this.nextEndDates = this.valueTime +"-"+this.dayms;
this.totalFeeMoney = this.sumMoney*timeNum;
},
setToday(){
let months = this.getMonths(this.endDates, this.valueTime);
this.setPayTime(months);
},
onChangeMonth(mIndex){
let timeNum = parseInt(mIndex);
this.feeBillList = [];
for(var i =1;i<=timeNum;i++){
let feeObj = new Object();
feeObj.month = this.subMonths(this.endDates , i);
this.feeBillList.push(feeObj);
this.valueTime = feeObj.month;
}
this.nextEndDates = this.valueTime +"-"+this.dayms;
this.totalFeeMoney = this.sumMoney*timeNum;
},
/*chanVal(){
$(".vux-datetime").find(".vux-cell-value").text(this.valueTime);
},*/
/*初始化时间选择*/
getInitSelectDate(){
let date = new Date()
date = new Date(date.getFullYear(),date.getMonth() + 1,date.getDate(), 1)
this.selectDate[0].push(date.getFullYear())
this.selectDate[0].push(date.getFullYear() + 1)
let curM = date.getMonth() + 1;
this.selectDate[1] = new Array();
for(let i = curM ; i < 13 ; i++){
this.selectDate[1].push(i);
}
let curD = date.getDate();
this.selectDate[2] = new Array();
for(let n = curD ; n < 31 ; n++){
this.selectDate[2].push(n);
}
},

submitBefore(kId,feeBz,monthCout){


let yzUrl = global.host + 'parkFeeBill/findownerunpaidorder?phoneNo='
+this.$router.history.current.query.phone+'&comnCode='+this.$router.history.current.query.comnCode
+'&openid='+this.$router.history.current.query.openid;
this.$http.get(yzUrl).then(function(res){
if(res.body.code == '110'){

let usinfo = new Object();
usinfo.comnCode = this.$router.history.current.query.comnCode;
usinfo.pkId = kId;
usinfo.feePrice = feeBz;
usinfo.feeCount = monthCout;
usinfo.discType = this.disTypes;
usinfo.freeMonth = 0;
usinfo.discMoney = 0;
usinfo.realMoney = this.totalFeeMoney;
usinfo.startDate = this.endDates;
usinfo.openId = this.$router.history.current.query.openid;
usinfo.mainPhone = this.$router.history.current.query.phone;

let urls = global.host + 'parkFeeBill/addParkFeeBill';
this.$http.post(urls,usinfo).then(function(res){
let statuCodes = res.body.statusCode;

if(statuCodes == '110'){
this.billCode = res.body.result.billCode;
console.log(res)
this.gopay();

}else if(statuCodes == '120'){
this.feeShow = true;
this.dailogMessage = "提交失败";
}
},function(err){
console.log(err)
})

}else if(res.body.code == '120'){
this.dailogMessage = '您有未处理的订单,请优先处理';
this.feeShow = true;
}
},function(err){
console.log(err)
})

},
/*去支付方法*/
gopay(){
let senddata = new Object();
senddata.comnCode = this.$router.history.current.query.comnCode;
senddata.memberNo = this.$router.history.current.query.phone;
senddata.openid = this.$router.history.current.query.openid;
senddata.tradeAmount = this.totalFeeMoney
senddata.tradeNo = this.billCode;
senddata.tradeName='车位费';
senddata.tradeDesc='车位费';
console.log(senddata)
let url = global.host + 'parkFeeBill/getpayurl';
this.$http.post(url,senddata).then(function(res){
if(res.body.code == '110'){
location.href = res.body.payurl;
}else{
this.feeShow = true;
this.dailogMessage = "支付异常,请稍候再试";
}
},function(err){
console.log(err)
})
},
/*根据不同的操作进行操作*/
refresh(){
if(this.dailogMessage == '您有未处理的订单,请优先处理'){
this.submitable = true;
this.$router.push({path:'/paymentRecord',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/carRentComponents/carPayComFee.vue